module.exports = __webpack_public_path__ + "img/balkonglasdach_2.9b0c32a9.jpg";